/* eslint-disable prefer-arrow/prefer-arrow-functions */
import Api from '@/services/ApiService';

export default {
  find() {
    return Api.get<Record<string, any>>('admin/settings');
  },
  updateSettings(settings: any) {
    return Api.patch<Record<string, any>>('admin/settings', settings);
  }
};
